import { request_fixedAssets } from 'src/api/models/request_fixedAssets'
import { request_fixedAssets_depreciationMethod } from 'src/api/models/request_fixedAssets_depreciationMethod'
import { response_fixedAsset } from 'src/api/models/response_fixedAsset'
import useSWR from 'swr'
import { useFixedAssets } from './useFixedAssets'
import { useNewApiClient } from './useNewApiClient'

export const useFixedAsset = (id: undefined | response_fixedAsset['id']) => {
  const { apiClient } = useNewApiClient()
  const { mutateFixedAssets } = useFixedAssets()
  const { data: fixedAsset, mutate: mutateFixedAsset } = useSWR(
    id ? `/fixed_assets/${id}` : null,
    async () => {
      const res = await apiClient.fixedAsset.getFixedAssetsId(String(id))
      return res
    }
  )

  const patchFixedAssetBasicInfo = async (fixedAsset: request_fixedAssets) => {
    if (id === undefined) return
    const res = await apiClient.fixedAsset.patchFixedAssetsIdBasicInformation(
      String(id),
      fixedAsset
    )
    await Promise.all([mutateFixedAsset(), mutateFixedAssets()])
    return res
  }
  const patchFixedAssetsDepreciationMethod = async (
    fixedAsset: request_fixedAssets_depreciationMethod
  ) => {
    if (id === undefined) return
    const res = await apiClient.fixedAsset.patchFixedAssetsIdDepreciationMethod(
      String(id),
      fixedAsset
    )
    await Promise.all([mutateFixedAsset(), mutateFixedAssets()])

    return res
  }

  const deleteFixedAsset = async () => {
    if (id === undefined) return
    const res = await apiClient.fixedAsset.deleteFixedAssetsId(String(id))
    await mutateFixedAssets()
    return res
  }

  return {
    fixedAsset,
    deleteFixedAsset,
    patchFixedAssetBasicInfo,
    patchFixedAssetsDepreciationMethod
  }
}
